import React, { useEffect, useState } from "react";
import Select from "react-select";
import apiClient from "../utils/apiClient";
import "bootstrap/dist/css/bootstrap.min.css";
import { SERVER_BASE } from "../config/server";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
  const stateOptions = [
    { value: 'As Stock', label: 'As Stock' },
    { value: 'Installed/Fitted with Structure', label: 'Installed/Fitted with Structure' },
    { value: 'Installed/Fitted with Machinery', label: 'Installed/Fitted with Machinery' },
    { value: 'Installed/Fitted with Construction', label: 'Installed/Fitted with Construction' },
    { value: 'Installed/Fitted underground', label: 'Installed/Fitted underground' },
    { value: 'Installed/Fitted above roof', label: 'Installed/Fitted above roof' },
    { value: 'Installed/Fitted under shed', label: 'Installed/Fitted under shed' },
    { value: 'Installed/Fitted above shed', label: 'Installed/Fitted above shed' },
    { value: 'Dormant Stock', label: 'Dormant Stock' },
    { value: 'Office Inventory', label: 'Office Inventory' },
    { value: 'As Condemnation Stock', label: 'As Condemnation Stock' },
  ];
const InventoryStatusTransfer = ({ accessOfDepartments }) => {
    const [transferDate, setTransferDate] = useState("");
    const [selectedDepartment, setSelectedDepartment] = useState(null);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [remarks, setRemarks] = useState("");
    const [departments, setDepartments] = useState([]);
    const [itemOptions, setItemOptions] = useState([]);
    const [locations, setLocations] = useState([]);
    const code = localStorage.getItem('code');
    const name = localStorage.getItem('name');
    const badgeId = localStorage.getItem('badgeId');
    const email = localStorage.getItem('email'); // Retrieve email from localStorage
    const role = localStorage.getItem('role'); // Retrieve email from localStorage
    const token = localStorage.getItem('token')
    const navigate = useNavigate();
    const [rows, setRows] = useState([
        {
            item: null,
            fromStatus: null,
            toStatus: null,
            availableQty: 0,
            transferQty: ""
        }
    ]);
      useEffect(() => {
        if (accessOfDepartments) {
          const deptArray = accessOfDepartments
            .split(',')
            .map((dept) => ({ value: dept.trim(), label: dept.trim() }));
          setDepartments(deptArray);
        }
      }, [accessOfDepartments]);
  useEffect(() => {
    fetchLocations();
  }, []);


  const fetchItemOptions = async (accessOfDepartmentsArray) => {
    try {
      const response = await apiClient.get(`${SERVER_BASE}/getItemOptionsByDepartment`, {
        params: {
          code,
          accessOfDepartments: accessOfDepartmentsArray.join(','),
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setItemOptions(
        response.data.map((item) => ({
          value: item.printName,
          itemId: item.id,
          label: `${item.printName}${item.additionalNames ? ` - [ ${item.additionalNames} ]` : ""}`,
          itemCode: item.itemCode,
          uom: item.uom,
          unit: item.unit
        }))
      );
    } catch (error) {
      console.error("Error fetching item data:", error.message);
    }
  };

  const fetchLocations = async () => {
    try {
      const response = await apiClient.get(SERVER_BASE + "/getLocations", {
        params: { code },
        headers: { Authorization: `Bearer ${token}` }
      });
      setLocations(
        response.data.map((location) => ({
          value: location.location,
          label: location.location
        }))
      );
    } catch (error) {
      console.error("Error fetching locations:", error);
    }
  };

const fetchAvailableQuantity = async (item, status, deptOverride, loctOverride) => { 

  try {
    const response = await apiClient.get(`${SERVER_BASE}/getAvailableQuantity`, {
      params: {
        item,
        location: loctOverride || selectedLocation?.value,
        status,
        code,
        department: deptOverride || selectedDepartment?.value,
      },
      headers: { Authorization: `Bearer ${token}` },
    });

    return response.data.availableQuantity || 0;
  } catch (error) {
    console.error('Error fetching available quantity:', error);
    return 0;
  }
};

  const handleDepartmentChange = async (selected) => {
  setSelectedDepartment(selected);
  fetchItemOptions([selected.value]);
  // Update available quantity for each row
  const updatedRows = await Promise.all(
    rows.map(async (row) => {
      if (row.item && row.fromStatus) {
        const qty = await fetchAvailableQuantity(row.item.itemId, row.fromStatus.value, selected.value, selectedLocation?.value);
        return { ...row, availableQty: qty };
      }
      return row;
    })
  );

  setRows(updatedRows);
};

  const handleLocationChange = async (selected) => {
  setSelectedLocation(selected);

  // Update available quantity for each row
  const updatedRows = await Promise.all(
    rows.map(async (row) => {
      if (row.item && row.fromStatus) {
        const qty = await fetchAvailableQuantity(row.item.itemId, row.fromStatus.value, selectedDepartment?.value, selected.value);
        return { ...row, availableQty: qty };
      }
      return row;
    })
  );

  setRows(updatedRows);
};
  const handleRowChange = async (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;

    const item = field === "item" ? value : updated[index].item;
    const fromStatus = field === "fromStatus" ? value : updated[index].fromStatus;

    // Fetch available quantity when item or fromStatus is changed

    if (item && fromStatus && selectedDepartment && selectedLocation) {
      const qty = await fetchAvailableQuantity(item.itemId, fromStatus.value, selectedDepartment?.value, selectedLocation?.value,);
      
      updated[index].availableQty = qty;

      // Optional: Reset transferQty if it's more than new availableQty
      if (updated[index].transferQty > qty) {
        updated[index].transferQty = qty;
      }
    }
    setRows(updated);
  };

  const handleQtyChange = (index, value) => {
    const updated = [...rows];
    updated[index].transferQty = value;
    setRows(updated);
  };

  const addRow = () => {
    setRows([
      ...rows,
      {
        item: null,
        fromStatus: null,
        toStatus: null,
        availableQty: 0,
        transferQty: ""
      }
    ]);
  };

  const removeRow = (index) => {
    const updated = rows.filter((_, i) => i !== index);
    setRows(updated);
  };
const handleSubmit = async (e) => {
  e.preventDefault();

  // Basic checks
  if (!transferDate) {
    return Swal.fire({ toast: true, position: 'top-end', icon: 'error', title: 'Date is required', timer: 3000, showConfirmButton: false });
  }

  if (!selectedDepartment) {
    return Swal.fire({ toast: true, position: 'top-end', icon: 'error', title: 'Department is required', timer: 3000, showConfirmButton: false });
  }

  for (let i = 0; i < rows.length; i++) {
    const row = rows[i];

    if (!row.item || !row.fromStatus || !row.toStatus || !row.transferQty) {
      return Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'error',
        title: `Please fill all fields in row ${i + 1}`,
        timer: 3000,
        showConfirmButton: false,
      });
    }

    if (Number(row.transferQty) > Number(row.availableQty)) {
      return Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'error',
        title: `Transfer qty cannot exceed available qty in row ${i + 1}`,
        timer: 3000,
        showConfirmButton: false,
      });
    }
  }

  const payload = {
    transferDate,
    department: selectedDepartment?.value,
    location:selectedLocation?.value,
    createdBy: name,
    createdByBadge: badgeId,
    centerCode:code,
    remarks,
    items: rows.map((row) => ({
        itemId: row.item?.itemId,
        item: row.item?.value,              // printName
        itemCode: row.item?.itemCode,
        uom: row.item?.uom,
        unit: row.item?.unit,

        fromStatus: row.fromStatus?.value,
        toStatus: row.toStatus?.value,
        availableQty: row.availableQty,
        transferQty: row.transferQty
    }))
    };


  try {
    await apiClient.post(`${SERVER_BASE}/saveStatusTransfer`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });

    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'success',
      title: 'Transfer submitted successfully!',
      timer: 3000,
      showConfirmButton: false,
    });
    navigate('../InventoryStatusTransferList')
    setTransferDate("");
    setSelectedDepartment(null);
    setRows([{
      item: null,
      fromStatus: null,
      toStatus: null,
      availableQty: 0,
      transferQty: ""
    }]);

  } catch (error) {
    console.error("Transfer Submit Error:", error);
    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'error',
      title: 'Failed to submit transfer',
      timer: 3000,
      showConfirmButton: false,
    });
  }
};


  return (
    <div className="formcontainer mt-5">
      <div className="d-flex justify-content-start align-items-end mb-3 gap-3">
        <button 
          className="btn btn-secondary btn-sm"
          onClick={() => navigate('../InventoryStatusTransferList')}
        >
          Back
        </button>
        <h4 className="mb-0">Status Transfer</h4>
      </div>


      <form onSubmit={handleSubmit}>
        <div className="row mb-3">
          <div className="col-md-3">
            <label className="form-label">Date</label>
            <input
              type="date"
              className="form-control"
              value={transferDate}
              onChange={(e) => setTransferDate(e.target.value)}
              required
            />
          </div>
            <div className="col-md-3">
            <label className="form-label">Department</label>
            <Select
                options={departments}
                value={selectedDepartment}
                onChange={handleDepartmentChange} 
                placeholder="Select Department"
                
                required
            />
            </div>
          <div className="col-md-3">
            <label className="form-label">Location</label>
            <Select
                options={locations}
                value={selectedLocation}
                onChange={handleLocationChange} 
                placeholder="Select Location"
                
                required
            />
            </div>
           <div className="col-md-3">
            <label className="form-label">Remarks</label>
            <input
              type="text"
              className="form-control"
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              
            />
          </div>
        </div>

        {/* Header Row with Labels */}
        <div className="row fw-bold mb-2">
        <div className="col-md-3">Item</div>
        <div className="col-md-2">From Status</div>
        <div className="col-md-2">Available Qty</div>
        <div className="col-md-2">To Status</div>
        <div className="col-md-2">Transfer Qty</div>
        <div className="col-md-1">Action</div>
        </div>

        {/* Dynamic Input Rows */}
        {rows.map((row, i) => (
        <div className="row align-items-center mb-2" key={i}>
            <div className="col-md-3">
            <Select
                options={itemOptions}
                value={row.item}
                onChange={(val) => handleRowChange(i, "item", val)}
                placeholder="Select Item"
            />
            </div>

            <div className="col-md-2">
            <Select
                options={stateOptions}
                value={row.fromStatus}
                onChange={(val) => handleRowChange(i, "fromStatus", val)}
                placeholder="From"
            />
            </div>

            <div className="col-md-2">
            <input
                type="number"
                className="form-control"
                value={row.availableQty}
                disabled
            />
            </div>

            <div className="col-md-2">
            <Select
                options={stateOptions}
                value={row.toStatus}
                onChange={(val) => handleRowChange(i, "toStatus", val)}
                placeholder="To"
            />
            </div>

            <div className="col-md-2">
            <input
                type="number"
                className="form-control"
                min="0"
                max={row.availableQty}
                value={row.transferQty}
                onChange={(e) => handleQtyChange(i, e.target.value)}
            />
            </div>

            <div className="col-md-1 d-flex gap-1">
            {i === rows.length - 1 && (
                <button
                type="button"
                className="btn btn-outline-primary btn-sm"
                onClick={addRow}
                >
                <FontAwesomeIcon icon={faPlus}/>
                </button>
            )}
            {rows.length > 1 && (
                <button
                type="button"
                className="btn btn-outline-danger btn-sm"
                onClick={() => removeRow(i)}
                >
                <FontAwesomeIcon icon={faTrash}/>
                </button>
            )}
            </div>
        </div>
        ))}
        <button type="submit" className="btn btn-success">
          Submit Transfer
        </button>
      </form>
    </div>
  );
};

export default InventoryStatusTransfer;
